// Ad System Types

export type AdLayoutType = 'hero' | 'bento' | 'carousel' | 'sidebar' | 'billboard'
export type AdNavType = 'browse' | 'detail' | 'search' | 'external'

export interface AdTrackingParams {
  pd_rd_w: string
  pd_rd_wg: string
  pd_rd_r: string
}

export interface AdItem {
  id: string
  image?: string // Legacy fallback
  desktop_image: string
  mobile_image: string
  headline: string
  description?: string
  cta_text?: string
  nav_type: AdNavType
  nav_value: string
  tracking: AdTrackingParams
  // Context-aware targeting fields (optional)
  target_categories?: string[]
  target_keywords?: string[]
}

export interface AdContextFilter {
  type: 'category' | 'keyword'
  field: string
}

export interface AdSlot {
  slot_id: string
  layout_type: AdLayoutType
  items: AdItem[]
  refresh_interval?: number // in seconds
  priority?: number
  context_filters?: AdContextFilter // For context-aware slots
}

export interface AdSlotData {
  [slotName: string]: AdSlot
}

// Context types for context-aware ad fetching
export interface AdSlotContext {
  categoryId?: string
  query?: string
  productId?: string
}

export interface UseAdsResult {
  data: AdSlot | null
  isLoading: boolean
  error: Error | null
  refetch: () => void
}

export interface UseAdSlotResult extends UseAdsResult {
  layoutType: AdLayoutType | null
}

// Helper function to construct ad URL with tracking params
export function getAdUrl(item: AdItem, slotId: string): string {
  const { nav_type, nav_value, tracking } = item
  const { pd_rd_w, pd_rd_wg, pd_rd_r } = tracking

  let basePath: string
  switch (nav_type) {
    case 'browse':
      basePath = `/browse?slug=${nav_value}`
      break
    case 'detail':
      basePath = `/products/${nav_value}`
      break
    case 'search':
      basePath = `/search?q=${encodeURIComponent(nav_value)}`
      break
    case 'external':
      // For external URLs, return as-is with tracking appended
      return `${nav_value}?pd_rd_w=${pd_rd_w}&pd_rd_wg=${pd_rd_wg}&pd_rd_r=${pd_rd_r}&ref=${slotId}_${item.id}`
    default:
      basePath = '/'
  }

  const separator = basePath.includes('?') ? '&' : '?'
  return `${basePath}${separator}pd_rd_w=${pd_rd_w}&pd_rd_wg=${pd_rd_wg}&pd_rd_r=${pd_rd_r}&ref=${slotId}_${item.id}`
}
